"use client";
import { useState, useRef, useEffect } from "react";
import AnimatedText from "./AnimatedText";
import AnimatedBlock from "./AnimatedBlock";

export default function RotatingText({ children }) {
	const texts = children;
	if (!texts || texts.length === 0) return null;

	const innerTextRef = useRef(null);
	const [carouselHeight, setCarouselHeight] = useState(null);
	const [textIndex, setTextIndex] = useState(0);
	const [isFading, setIsFading] = useState(false);

	const nextText = () => {
		const button = document.querySelector(".text-cycle-button");
		if (button) {
			button.classList.add("active");
			setTimeout(() => button.classList.remove("active"), 500);
		}

		setIsFading(true);
		setTimeout(() => setTextIndex((prev) => (prev + 1) % texts.length), 200);
		setTimeout(() => setIsFading(false), 300);
	};

	useEffect(() => {
		const el = innerTextRef.current;
		if (!el) return;

		const observer = new ResizeObserver(() => {
			setCarouselHeight(el.offsetHeight);
		});
		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	return (
		<div className="carousel-text" style={{ height: carouselHeight ? `${carouselHeight}px` : undefined }}>
			<AnimatedBlock className="text-cycle-button">
				<div>
					<button onClick={nextText}>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
							<path d="M48.66,14.56c-1.19-.7-2.72-.3-3.42.89l-1.49,2.54c-2.85-7.59-10.16-13.02-18.73-13.02-7.13,0-13.77,3.84-17.34,10.01-.69,1.19-.28,2.72.91,3.42,1.2.69,2.72.28,3.42-.91,2.68-4.63,7.67-7.51,13.02-7.51,6.59,0,12.19,4.27,14.21,10.18l-3.71-2.17c-1.19-.7-2.72-.3-3.42.89s-.3,2.72.89,3.42l8.29,4.86c.14.07.28.13.43.18.05.02.1.04.16.05.18.04.37.07.56.07s.39-.03.57-.07c.05-.01.1-.03.16-.05.14-.04.27-.09.4-.16.05-.03.11-.05.16-.09.14-.09.27-.18.39-.29.02-.02.05-.04.07-.06.14-.14.26-.3.36-.47.01-.02.03-.03.04-.05l4.86-8.29c.7-1.19.3-2.72-.89-3.42Z" />
							<path d="M41.44,31.6c-1.19-.69-2.72-.28-3.42.91-2.68,4.63-7.67,7.51-13.02,7.51-6.59,0-12.19-4.27-14.21-10.18l3.71,2.17c1.19.7,2.72.3,3.42-.89.7-1.19.3-2.72-.89-3.42l-8.29-4.86c-.09-.04-.17-.08-.25-.12-.08-.03-.15-.05-.23-.07-.08-.02-.16-.04-.24-.06-.09-.02-.18-.02-.27-.03-.05,0-.1-.01-.15-.01-.03,0-.05,0-.07,0-.09,0-.18.01-.27.03-.08.01-.15.02-.22.04-.08.02-.16.05-.23.07-.08.03-.15.05-.23.08-.07.03-.14.08-.21.12-.07.04-.14.08-.2.12-.07.05-.13.1-.19.16-.06.05-.12.1-.17.16s-.1.12-.15.18c-.05.07-.11.14-.15.21-.01.02-.03.04-.05.06L.47,32.02c-.7,1.19-.3,2.72.89,3.42.4.23.83.34,1.26.34.86,0,1.69-.44,2.16-1.24l1.49-2.54c2.85,7.59,10.16,13.02,18.73,13.02,7.13,0,13.77-3.84,17.34-10.01.69-1.2.28-2.72-.91-3.42Z" />
						</svg>
					</button>
				</div>
			</AnimatedBlock>
			<div className={`inner-text ${isFading ? "fade-out" : ""}`} ref={innerTextRef}>
				<AnimatedText variant="bounce" key={textIndex}>
					<h2>{texts[textIndex]}</h2>
				</AnimatedText>
			</div>
		</div>
	);
}
